export const COLLECTIONS = Object.freeze({
  RECIPES: 'Recipes',
  FILTERS: 'Filters',
  WEEKLY_MENU: 'WeeklyMenu',
  ADMINS: 'Admins',
  MEASUREMENTS: 'Measurements',
  USERS: 'Profiles',
});

export const STORAGES = Object.freeze({
  RECIPES: '/recipes',
  ADMINS: '/admins',
});

export const FUNCTIONS = Object.freeze({
  CREATE_ADMIN: 'createAdmin',
});
